import s from './style.module.scss';
import { cardStatusText } from '@/utils/contants/caseSimulation';
import { ExclamationCircleFilled, RedoOutlined } from '@ant-design/icons';
import { Display } from '@/components/Display/Display';

import okImg from '@/assets/images/simulation/card_ok.png';
import okGreyImg from '@/assets/images/simulation/card_ok_grey.png';
import withRouter from '@/components/withRouter';
import { inject, observer } from 'mobx-react';

import useAiCard from '@/pages/hooks/CaseSImulation/useAiCard';

const AiCard = (props) => {
    const { cardData, status, goCaseSimulation, reGenerate } = useAiCard(props);
    return (
        <div className={s['ai-card-wrap']} onClick={goCaseSimulation}>
            <div className={`${s['card-status']} ${status === 1 ? ['loading-text'] : ''}`} data-text={cardStatusText[status] || cardData?.message}>
                {cardStatusText[status] || cardData?.message}
            </div>
            <Display show={cardData?.case_title}>
                <div className={s['card-content']} data-status={status}>
                    <div className={s['card-icon']}>
                        <span className={s['card-status-icon']}>
                            <Display show={status === 2}>
                                <img src={okImg} alt="" />
                            </Display>
                            <Display show={status === 1}>
                                <img src={okGreyImg} alt="" />
                            </Display>
                            <Display show={status === 0}>
                                <ExclamationCircleFilled className={s['exclamation-icon']} />
                            </Display>
                        </span>
                    </div>
                    <div className={s['card-main-content']}>
                        <div className={s['card-title']}>
                            <span className={s['card-title-text']}>{cardData?.case_title}</span>
                        </div>
                        <div className={s['card-description']} status={status}>
                            <Display show={status === 0}>
                                <span onClick={reGenerate} className={s['redo-text']}>
                                    <RedoOutlined className={s['redo-icon']} />
                                    重新生成
                                </span>
                            </Display>
                            <Display show={status === 1}>
                                <span className={s['loading-text']}>正在生成...</span>
                            </Display>
                            <Display show={status === 2}>
                                <span className={s['ai-text']}>AI生成</span>
                            </Display>
                        </div>
                    </div>
                </div>
            </Display>
        </div>
    );
};
export default withRouter(inject('store')(observer(AiCard)));
